import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection } from "@firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDUJmnE6zoGATx0oFulwuioVLf6umh8vYM",
    authDomain: "chatbook-f57ae.firebaseapp.com",
    projectId: "chatbook-f57ae",
    storageBucket: "chatbook-f57ae.appspot.com",
    messagingSenderId: "705396750622",
    appId: "1:705396750622:web:239c81f796a4d90e17f10f",
    measurementId: "G-PZGR54B3D1"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const messagesRef = collection(db, "messages");
const usersRef = collection(db, "users");

export { db, auth, messagesRef, usersRef };
